<template lang="">
  <component
    :is="isMobileView ? 'Stack' : 'HStack'"
    class="gap-2"
  >
    <!-- ANCHOR stationType -->
    <b-form-group
      :label="$t('utils.flightsSchedule.filters.stationType')"
      label-for="station-type-select"
      class="flex-1 mb-0"
    >
      <v-select
        id="station-type-select"
        :options="stationTypeSupported"
        searchable
        filterable
        :clearable="false"
        :value="stationTypeFilter"
        :placeholder="$t('placeholderSelect')"
        :reduce="val => val"
        @input="(val) => { $emit('update:stationTypeFilter', val) }"
      >
        <template #selected-option="{ label }">
          {{ $t(`utils.flightsSchedule.stationType.${label}`) || label }}
        </template>
        <template #option="{ label }">
          {{ $t(`utils.flightsSchedule.stationType.${label}`) || label }}
        </template>
      </v-select>
    </b-form-group>

    <!-- ANCHOR tripType -->
    <b-form-group
      :label="$t('utils.flightsSchedule.filters.tripType')"
      label-for="trip-type-select"
      class="flex-1 mb-0"
    >
      <v-select
        id="trip-type-select"
        :options="TRIP_TYPE_OPTIONS"
        searchable
        filterable
        :clearable="false"
        :value="tripTypeFilter"
        :placeholder="$t('placeholderSelect')"
        :reduce="val => val.value"
        @input="(val) => { $emit('update:tripTypeFilter', val) }"
      >
        <template #selected-option="{ label }">
          {{ $t(`utils.flightsSchedule.tripType.${label}`) || label }}
        </template>
        <template #option="{ label }">
          {{ $t(`utils.flightsSchedule.tripType.${label}`) || label }}
        </template>
      </v-select>
    </b-form-group>

    <!-- ANCHOR departure -->
    <b-form-group
      :label="$t('utils.flightsSchedule.filters.departure')"
      label-for="departure-select"
      class="flex-1 mb-0"
    >
      <v-select
        id="departure-select"
        :options="airportSupported"
        searchable
        filterable
        label="code"
        :clearable="false"
        :value="departureFilter"
        :placeholder="$t('placeholderSelect')"
        :reduce="val => val.code"
        @input="(val) => { $emit('update:departureFilter', val) }"
      >
        <template #selected-option="{ code, name }">
          <HStack>
            {{ name || $t(`utils.flightsSchedule.airport.${code}`) || code }}
            <span>
              ({{ code }})
            </span>
          </HStack>
        </template>
        <template #option="{ code, name }">
          <HStack>
            {{ name || $t(`utils.flightsSchedule.airport.${code}`) || code }}
            <span>
              ({{ code }})
            </span>
          </HStack>
        </template>
      </v-select>
    </b-form-group>

    <!-- ANCHOR departure date -->
    <IAmDatePicker
      id="departure-date-picker"
      :date="departureDateFilter"
      :placeholder="$t('placeholderSelect')"
      :label="$t('utils.flightsSchedule.filters.departureDate')"
      :configs="{
        altInputClass: 'form-control',
      }"
      customClass=""
      class="flex-1 mb-0"
      @input="val => { if (val) { $emit('update:departureDateFilter', val) }}"
    />

    <b-form-group
      :label="$t('utils.flightsSchedule.filters.departureHour')"
      label-for="departure-hour-select"
      class="flex-1 mb-0"
    >
      <v-select
        id="departure-hour-select"
        :options="DEPARTURE_HOUR_OPTIONS"
        searchable
        filterable
        :clearable="false"
        :value="departureHourFilter"
        :placeholder="$t('placeholderSelect')"
        :reduce="val => val.value"
        @input="(val) => { $emit('update:departureHourFilter', val) }"
      >
        <template #selected-option="{ label }">
          {{ label === 'ALL' ? $t('All') : label }}
        </template>
        <template #option="{ label }">
          {{ label === 'ALL' ? $t('All') : label }}
        </template>
      </v-select>
    </b-form-group>
  </component>
</template>
<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

import { DEPARTURE_HOUR_OPTIONS, TRIP_TYPE_OPTIONS } from './useFlightsSchedule'

export default {
  components: {
    vSelect,
    BFormGroup,
    IAmDatePicker: () => import('@/components/IAmDatePicker.vue'),
  },
  props: {
    departureFilter: {
      type: String,
      default: '',
    },
    airportSupported: {
      type: Array,
      default: () => [],
    },
    departureDateFilter: {
      type: String,
      default: '',
    },
    tripTypeFilter: {
      type: String,
      default: '',
    },
    stationTypeFilter: {
      type: String,
      default: '',
    },
    stationTypeSupported: {
      type: Array,
      default: () => [],
    },
    departureHourFilter: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      // STATION_TYPE_OPTIONS,
      // DEPARTURE_OPTIONS,
      TRIP_TYPE_OPTIONS,
      DEPARTURE_HOUR_OPTIONS,
    }
  },
}
</script>
<style lang="">

</style>
